import { graphql } from "gql.tada";

const MenuFragment = graphql(`
  fragment MenuFragment on MenuPage {
    id
    url
    isPDF
    lastEdited
    menuImages {
      edges {
        node {
          id
          page
          url
          originalWidth
          originalHeight
        }
      }
    }
  }
`);

export default MenuFragment;
